import * as React from 'react'
// libs
import { useAuiState } from '@assistant-ui/react'
// icons
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined'
// views
import { FileChip, FileChipName, SentImage } from '../AttachmentChip/views'

const SentAttachmentChip: React.FC = () => {
  const attachment = useAuiState((s: any) => s.attachment)

  const { name, type, content } = attachment

  const url = content?.[0]?.text

  if (type === 'image' && url) {
    return <SentImage src={url} alt={name} />
  }

  return (
    <FileChip>
      <InsertDriveFileOutlinedIcon sx={{ fontSize: 14, flexShrink: 0, opacity: 0.6 }} />
      <FileChipName title={name}>{name}</FileChipName>
    </FileChip>
  )
}

export default SentAttachmentChip
